import React from "react";
import { Link } from "react-router-dom";
import { officeDeatils } from "../../../interface/officedetails.interface";
import ImageGalleryModal from "../components/imageGalleryModal"

function OurBranches({ officeDetails }: { officeDetails: officeDeatils[] }) {
  const filteredOffices =
    officeDetails.filter((office) => office.images.length > 0) || [];
  return (
    <section className="branchWrapper py-100">
      <div className="container">
        <div className="row">

          <div className="col-12 mb-5">
            {filteredOffices && (
              <h2 className="titleMain">OUR BRANCHES</h2>
            )}
          </div>
          {filteredOffices.map((item, index) => {
            return (
              <div
                className="col-lg-6 col-md-6 col-sm-6 col-12 mb-4"
                key={index}
              >
                <div className="branchAddressBox">
                  <div
                    className="branchImg"
                    data-bs-toggle="modal"
                    data-bs-target={`#imgGallery${index}`}
                  >
                    <img
                      src={item.images[0] || "/assets/images/center-img1.webp"}
                      alt={item.officeName}
                    />
                  </div>
                  <div className="branchBody">
                    <h2>{item.cities || item.officeName}</h2>
                    <div className="addressMain">
                      <p>{item.officeName}</p>
                      {item.addressLine1 && <p>{item.addressLine1}</p>}
                      {item.addressLine2 && <p>{item.addressLine2}</p>}
                      {item.cities && item.state && item.pincode && <p>{item.cities}, {item.state} {item.pincode}</p>}
                    </div>
                    <div className="contactMain">
                      {item.mobileNo && (
                        <p>
                          <Link to={`tel:${item.mobileNo}`}>
                            <i className="fa fa-phone me-1"></i>
                            {item.mobileNo}
                          </Link>
                        </p>
                      )}
                      {item.emailAddress && (
                        <p>
                          <a href={`mailto:${item.emailAddress}`}>
                            <i className="fa fa-envelope me-1"></i>
                            {item.emailAddress}
                          </a>
                        </p>
                      )}
                      {item.location && (
                        <p className="mt-3">
                          <Link
                            to={item.location}
                            target="_blank"
                            style={{ color: "#0b44ef", textDecoration: "none" }}
                          >
                            <i className="fa fa-map-marker me-1"></i>
                            Click For Map
                          </Link>
                        </p>
                      )}
                    </div>
                  </div>
                </div>
                <ImageGalleryModal
                  id={`imgGallery${index}`}
                  title={item.officeName}
                  images={item.images}
                />
              </div>
            );
          })}
        </div>
      </div>
    </section >
  );
}

export default OurBranches;